import request from '@/service';
export function getBchronPangaea(Hole) {
  return request.get(`/bchron_pangaea/${Hole}`);
}
export function getStratigraphy(Hole) {
  return request.get(
    `/stratigraphic/get_stratigraphic_events_by_hole?holes=${Hole}`
  );
}
// export function getAllStratigraphyLegHole() {
//   return request.get('/stratigraphic/get_all_stratigraphic_Leg_Hole');
// }
export function getAllStratigraphyHole() {
  return request.get('/stratigraphic/get_all_stratigraphic_hole');
}
export function findHoleByAgerange(start, end) {
  return request.get(
    `/age_range/find_hole_by_age_range?begin_age=${start}&end_age=${end}`
  );
}
export function getAllAgeModelHole() {
  return request.get('/age_depth_model/get_all_hole');
}
export function getBchronByHole(hole) {
  return request.get(`/age_depth_model/get_bchron?holes=${hole}`);
}

export function getPangaeaByHole(hole) {
  return request.get(`/age_depth_model/get_pangaea?hole=${hole}`);
}
export function getStratigraphicEventsByHole(hole) {
  return request.get(`/age_depth_model/get_stratigraphic_events?hole=${hole}`);
}
export function getVirtualHoleByLatLon(coordinates) {
  return request.get(
    `/virtual_hole/getVirtualHoleByLatLon?latitude=${coordinates[1]}&longitude=${coordinates[0]}`
  );
}
export function getNumber() {
  return request.get('/download/getNumber');
}
export function addNumber() {
  return request.get('/download/addNumber');
}
